import { User } from '@relewise/client';
import { useCookieConsent } from '~/components/features/Cookiebot/hooks/useCookieConsent/useCookieConsent';
import { useAuthentication } from '~/shared/hooks/useAuthentication/useAuthentication';
import { useEffect, useState } from 'react';

export const useRelewiseUser = () => {
  const { isAuthenticated, session } = useAuthentication();
  const consent = useCookieConsent();
  const [temporaryUserId, setTemporaryUserId] = useState<string>();

  useEffect(() => {
    if (!temporaryUserId) {
      const storedId = localStorage.getItem('relewise_temp_user_id');
      if (storedId) {
        setTemporaryUserId(storedId);
      } else {
        const newId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        localStorage.setItem('relewise_temp_user_id', newId);
        setTemporaryUserId(newId);
      }
    }
  }, [temporaryUserId]);

  const hasConsentToTrack = consent.necessary && consent.marketing;

  const user: User = {
    authenticatedId: isAuthenticated ? session?.user?.email : undefined,
    temporaryId: temporaryUserId,
  };

  return {
    user: hasConsentToTrack ? user : undefined,
    hasConsent: hasConsentToTrack,
  };
};